import Swal from 'sweetalert2';

const Swalaleart = ({ title = '', text = '', icon = '', confirmColor = '#1fee5b' }) => {
  Swal.fire({
    title: title,
    text: text,
    icon: icon,
    confirmButtonColor: confirmColor,
  });
};

export default Swalaleart;
